"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DecryptNoCertError = exports.SignError = exports.CommonError = exports.ErrorCodes = void 0;
exports.isDecryptNoCertError = isDecryptNoCertError;
exports.isNoSuitableCryptoProviderError = isNoSuitableCryptoProviderError;
exports.isUnknownEncryptionAlgorithmError = isUnknownEncryptionAlgorithmError;
var ErrorCodes = /** @class */ (function () {
    function ErrorCodes() {
    }
    ErrorCodes.Cancelled = "Cancelled";
    ErrorCodes.HttpError = "HttpError";
    ErrorCodes.NoHttpResponse = "NoHttpResponse";
    ErrorCodes.Unknown = "Unknown";
    ErrorCodes.Toolbox = "Toolbox";
    ErrorCodes.NoToolbox = "NoToolbox";
    ErrorCodes.MaxAttemptsExceeded = "MaxAttemptsExceeded";
    ErrorCodes.InvalidArgument = "InvalidArgument";
    ErrorCodes.IOFileError = "IOFileError";
    ErrorCodes.CloudDecrypt = "CloudDecrypt";
    ErrorCodes.DecryptNoCert = "DecryptNoCert";
    ErrorCodes.CorruptedBase64 = "corrupted-base64";
    ErrorCodes.DssUserHasUnconfirmedOperation = "UserHasUnconfirmedOperation";
    ErrorCodes.Mismatch = "Mismatch";
    return ErrorCodes;
}());
exports.ErrorCodes = ErrorCodes;
var CommonError = /** @class */ (function () {
    function CommonError(message, userMessage, errorCode, details, inner) {
        this.userMessage = userMessage;
        this.details = details;
        this.inner = inner;
        this.message = message || "";
        this.code = errorCode ? errorCode : ErrorCodes.Unknown;
        if (Error.hasOwnProperty("captureStackTrace")) {
            Error.captureStackTrace(this);
        }
        else {
            this.stack = new Error().stack;
        }
    }
    return CommonError;
}());
exports.CommonError = CommonError;
CommonError.prototype = Object.create(Error.prototype);
var SignError = /** @class */ (function (_super) {
    __extends(SignError, _super);
    function SignError(certificatesInfo, message, userMessage, errorCode, details, inner) {
        var _this = _super.call(this, message, userMessage, errorCode, details, inner) || this;
        _this.certificatesInfo = certificatesInfo;
        return _this;
    }
    return SignError;
}(CommonError));
exports.SignError = SignError;
var DecryptNoCertError = /** @class */ (function (_super) {
    __extends(DecryptNoCertError, _super);
    function DecryptNoCertError(encryptedOnSerials, message, userMessage, details, inner) {
        var _this = _super.call(this, message, userMessage, ErrorCodes.DecryptNoCert, details, inner) || this;
        _this.certs = encryptedOnSerials;
        return _this;
    }
    return DecryptNoCertError;
}(CommonError));
exports.DecryptNoCertError = DecryptNoCertError;
function isDecryptNoCertError(error) {
    return error.code === ErrorCodes.DecryptNoCert && !!error["certs"];
}
function isNoSuitableCryptoProviderError(error) {
    return (error.code === ErrorCodes.Toolbox &&
        error.details &&
        error.details.type === "crypto" &&
        error.details.code === 10);
}
function isUnknownEncryptionAlgorithmError(error) {
    if (error.code === ErrorCodes.Toolbox && error.details) {
        var _a = error.details, type = _a.type, code = _a.code;
        return ((type === "crypto" && code === 24) ||
            (type === "system" && code === 2148073482));
    }
    return false;
}
